import { CustomerListDto } from '@careapp-group/ng-sdk/model/customerListDto';
import { CareAppListActionFactory } from '../action-factory';
import { createAction, props } from '@ngrx/store';

class CustomerListsActions extends CareAppListActionFactory<CustomerListDto> {
  constructor(modelName: string) {
    super(modelName);
  }

  get REQUEST_PATCH_BY_ID() {
    return `[${this.type}][Request] Patch by ID`;
  }

  get RESPONSE_SUCCESS_PATCH_BY_ID() {
    return `[${this.type}][Response][Success] Patch by ID`;
  }

  get RESPONSE_FAIL_PATCH_BY_ID() {
    return `[${this.type}][Response][Fail] Patch by ID`;
  }

  UpdateCustomerListFilterAction = createAction(
    this.UPDATE_FILTER,
    props<{
      payload: {
        name?: string;
      };
    }>()
  );

  RequestPatchById = createAction(
    this.REQUEST_PATCH_BY_ID,
    props<{ customerListId: string; name?: string; updatedCustomerIds?: string[] }>()
  );
  ResponseSuccessPatchById = createAction(
    this.RESPONSE_SUCCESS_PATCH_BY_ID,
    props<{ payload: CustomerListDto }>()
  );
  ResponseFailPatchById = createAction(
    this.RESPONSE_FAIL_PATCH_BY_ID,
    props<{ id: string; error: any }>()
  );
}

export const CustomerLists = new CustomerListsActions(`CustomerLists`);
